export class ApiResponseError {
    key: string;
    errors: Array<string>;

    constructor() {
        this.errors = new Array<string>();
    }

    addError(error: string): ApiResponseError {
        this.errors.push(error);
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/api-response-models/api-response-error.model.ts